import {Component, OnDestroy} from '@angular/core';
import {NgbActiveModal, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ReportType} from '../models/report-type.model';
import {EMPTY_TEXT, INITIAL_COUNTER_VALUE, STANDARD_REPORT_TAB} from './report-datepicker.constants';
import {ReportDatepickerActionCoordinator} from './report-datepicker-action.coordinator';
import {ReportDatepickerDateCoordinator} from './report-datepicker-date.coordinator';
import {REPORT_DATEPICKER_PROVIDERS} from './report-datepicker.providers';
import {ReportDatepickerReportCoordinator} from './report-datepicker-report.coordinator';
import {ReportDatepickerShiftCoordinator} from './report-datepicker-shift.coordinator';
import {
  CurrentVacation,
  GroupData,
  ShiftSchedule,
  SuccessParams
} from './report-datepicker.types';
import {ReportDatepickerVacationCoordinator} from './report-datepicker-vacation.coordinator';
import {
  REPORT_PROGRESS_DEFAULT_STAGE,
  REPORT_PROGRESS_INITIAL_PERCENT,
  REPORT_PROGRESS_STAGE_PREFIX
} from './report-progress.constants';
import {ReportProgressView} from './report-progress.types';
import {VacationTypeCreation} from './vacation-type-creation';
import {VacationTypes} from './vacation-Types';

@Component({
  selector: 'app-report-datepicker',
  templateUrl: './report-datepicker.component.html',
  styleUrls: ['./report-datepicker.component.css'],
  providers: REPORT_DATEPICKER_PROVIDERS
})
export class ReportDatepickerComponent implements OnDestroy, ReportProgressView {
  from: NgbDateStruct;
  to: NgbDateStruct;
  today: Date;
  userId: string;
  reportType: ReportType;
  groupId: GroupData;
  groupName: string;
  wrongIntervalError = false;
  wrongError = false;
  wrongError409 = false;
  payrollOperationPending = false;
  wrongError400 = false;
  noScheduleError = false;
  emptyIntervalError = false;
  wrongHeadError = false;
  title: string;
  rep: string;
  dateErrorContent = false;
  suc = false;
  successMessage = false;
  isWaiting = false;
  changeLog = EMPTY_TEXT;
  modalLogWindow: boolean;
  actionType: string;
  activeUserId: string;
  currentValue = INITIAL_COUNTER_VALUE;
  type = VacationTypes.NOT_CHOSEN;
  timeErr: boolean;
  shift = INITIAL_COUNTER_VALUE;
  currentShift: ShiftSchedule | string | number;
  scheduleId: string;
  group: GroupData;
  scheduleId1: string;
  scheduleId2: string;
  scheduleId3: string;
  shiftCurrent: ShiftSchedule;
  shiftPlanned: ShiftSchedule;
  checkValue = true;
  currenValue = false;
  currentValue2 = true;
  currentValue3 = true;
  currentFrom: string;
  currentTo: string;
  planned: string;
  current = true;
  stateShift: number;
  flagDeleteBtn = false;
  plannedId: string;
  disableFlag = true;
  shiftError: boolean;
  currentVacations: CurrentVacation[] = [];
  isLoaded = true;
  dealPayrollGroupError = false;
  showReportProgress = false;
  reportProgressPercent = REPORT_PROGRESS_INITIAL_PERCENT;
  reportProgressStageKey = REPORT_PROGRESS_STAGE_PREFIX + REPORT_PROGRESS_DEFAULT_STAGE;
  currentFlexbleId: string;
  currentTab = STANDARD_REPORT_TAB;
  selectedShiftId: string;
  dateCurrent: NgbDateStruct;
  dateStart: NgbDateStruct;
  minDateForExpirence: NgbDateStruct;
  vocationDays: number;
  successKey: VacationTypeCreation;
  successParams: SuccessParams | null = null;
  showConfirmationScreen = false;
  prolongationDays = 0;
  newEndDate: NgbDateStruct;
  VacationTypeEnum = VacationTypes;

  constructor(
    public activeModal: NgbActiveModal,
    private dates: ReportDatepickerDateCoordinator,
    private reports: ReportDatepickerReportCoordinator,
    private vacations: ReportDatepickerVacationCoordinator,
    private shifts: ReportDatepickerShiftCoordinator,
    private actions: ReportDatepickerActionCoordinator
  ) {
  }

  ngOnInit(): void {
    this.dates.initializeCalendarBounds(this);
    if (this.reportType === ReportType.SHIFT) {
      this.shifts.loadShift(this, this.userId);
    } else {
      this.dates.initializeReportDates(this);
    }
  }

  ngOnDestroy(): void {
    this.reports.destroy();
    this.vacations.unpaidPreview.ngOnDestroy();
  }

  submitReportRequest(): void {
    this.reports.submitReportRequest(this);
  }

  onFromDateChange(date: NgbDateStruct): void {
    this.dates.updateFrom(this, date);
    this.reports.cancelGroupOnDateChange(this);
  }

  onToDateChange(date: NgbDateStruct): void {
    this.dates.updateTo(this, date);
    this.reports.cancelGroupOnDateChange(this);
  }

  setSelect(value: string): void {
    this.vacations.selectType(this, value);
  }

  get unpaidPreview() { return this.vacations.unpaidPreview; }

  refreshUnpaidPreview(): void { this.unpaidPreview.refresh(this); }

  actionTWO(action: string, id: string): void {
    this.actions.selectAction(this, action, id);
  }

  disabledBtn(): boolean {
    return this.actions.isActionEnabled(this);
  }

  plus(): void {
    this.actions.incrementAmount(this);
  }

  minus(): void {
    this.actions.decrementAmount(this);
  }

  setChangeLog(): void {
    this.actions.saveKarmaChange(this);
  }

  setEmployer(): void {
    this.actions.saveEmploymentDate(this);
  }

  shifyChnage(shift: number, scheduleId: string): void {
    this.shifts.selectShift(this, shift, scheduleId);
  }

  changeTab(tab: string): void {
    this.shifts.changeTab(this, tab);
  }

  deleteEvent(): void {
    this.shifts.deletePlannedShift(this);
  }

  cancelConfirmationRequest(): void {
    this.vacations.cancelConfirmation(this);
  }

  isDisabled(): boolean {
    return this.vacations.isSubmissionDisabled(this);
  }

  isContinueDisabled(): boolean {
    return this.shifts.isSubmissionDisabled(this);
  }

  submitVacationRequest(): void {
    this.vacations.submitRequest(this);
  }

  prepareProlongationConfirmation(daysToAdd: number): void {
    this.vacations.prepareProlongation(this, daysToAdd);
  }

  sendRequest(): void {
    this.reports.sendRequest(this);
  }

  action(title: string): void {
    this.actions.setTitle(this, title);
  }

  getPlanfixUrl(taskId: number): string {
    return this.actions.planfixUrl(taskId);
  }

  openPlanfixTask(taskId: number): void {
    this.actions.openPlanfix(taskId);
  }

  private startGroupReportGeneration(from: string, to: string): void {
    this.reports.startGroupReportGeneration(this, from, to);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker.component.ts